"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gorla-minore": {
    "7ff57b05": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-deserto": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2cbcb302": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-mirabello": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9b51e3c4": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "skipSearch": false
    }],
    "lazzaretto": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "129dc085": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "skipSearch": false
    }],
    "nasaccia": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7091b7b1": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "skipSearch": false
    }],
    "sciaccona": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3790d2ef": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "skipSearch": false
    }],
    "vacche": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1913352d": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "skipSearch": false
    }],
    "villa-solbiati": [{
      "hkey": "9a3d504f",
      "slug": "gorla-minore",
      "name": "Gorla Minore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;